module.exports = __webpack_public_path__ + "static/media/santos_logo.92e04d9e.jpg";